export const getProcessinguuid = () => {
  const processingUuid = window.localStorage.getItem('processing_uuid')
  return processingUuid || ''
}
